import { manutencaoEstaTravada, type EstadoParaDecisaoDeTrava } from "./manutencaoTravada";

/**
 * O aviso GRANDE do login (PR 2, 28/09/2026 — decisão do Augusto): aparece
 * DESDE a contagem regressiva da carência (manutenção ativada, ainda sem
 * travar) e continua depois de travar. Também decide se as telas públicas de
 * recuperação/ativação ficam fechadas — ver `FechadaNaManutencao.tsx`.
 *
 * `fimDaContagem` é o mesmo `gracePeriodEndsAt` cru do estado — quem exibe
 * decide como formatar (`formatarPrevisaoDeVolta`, do designer).
 */
export type EstadoDoAvisoNoLogin =
  | { tipo: "contagem"; fimDaContagem: string }
  | { tipo: "travada" };

/**
 * null sem manutenção ativa, em escopo `partial` (só os módulos afetados
 * travam — o login segue liberado e útil) ou nível `level_3` (somente-
 * leitura: entrar pra ler é permitido, sem aviso nenhum).
 *
 * Fora desses três casos, reaproveita `manutencaoEstaTravada` — MESMA regra
 * do backend (`is_login_blocked`) — sem duplicá-la: se ela diz que não está
 * travada, só pode ser porque a carência ainda está na fase warn/save (é a
 * única saída de `manutencaoEstaTravada` além de escopo partial/level_3, já
 * descartados acima), então é a contagem regressiva.
 */
export function avisoDeManutencaoNoLogin(
  estado: EstadoParaDecisaoDeTrava
): EstadoDoAvisoNoLogin | null {
  if (!estado.isActive) return null;
  if (estado.scope === "partial") return null;
  if (estado.level === "level_3") return null;

  if (manutencaoEstaTravada(estado)) return { tipo: "travada" };

  // Não travada aqui só acontece na carência (fase warn/save) — o valor é
  // sempre uma ISO string válida nesse ramo (é o que faz `manutencaoEstaTravada`
  // devolver false).
  return { tipo: "contagem", fimDaContagem: estado.gracePeriodEndsAt as string };
}
